import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { extractColors } from '@utils/utils';
import Markdown from '@components/Shared/Markdown/Markdown';
import BuilderLinksByStateStyles from './BuilderLinksByState.Styled';
import { lg_mobile_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import ChevronDown from './chevron-down.svg';
import ChevronUp from './chevron-up.svg';

const BuildersByState = [
  {
    builderName: 'Harris Doyle',
    stateCd: 'AL',
    id: 'harris-doyle-homes',
  },
  {
    builderName: 'Legacy Homes',
    stateCd: 'AL',
    id: 'legacy-homes',
  },
  {
    builderName: 'Oakwood Homes',
    stateCd: 'AZ',
    id: 'oakwood-homes',
  },
  {
    builderName: 'Oakwood Homes',
    stateCd: 'CO',
    id: 'oakwood-homes',
  },
  {
    builderName: 'Harris Doyle',
    stateCd: 'FL',
    id: 'harris-doyle-homes',
  },
  {
    builderName: 'Highland Homes',
    stateCd: 'FL',
    id: 'highland-homes',
  },
  {
    builderName: 'Chafin Communities',
    stateCd: 'GA',
    id: 'chafin-communities',
  },
  {
    builderName: 'Mungo Homes',
    stateCd: 'GA',
    id: 'mungo-homes',
  },
  {
    builderName: 'Summit Homes',
    stateCd: 'IA',
    id: 'summit-homes',
  },
  {
    builderName: 'Berkely Building Co.',
    stateCd: 'ID',
    id: 'berkeley-building-co.',
  },
  {
    builderName: 'Arbor Homes',
    stateCd: 'IN',
    id: 'arbor-homes®',
  },
  {
    builderName: 'Silverthorne Homes',
    stateCd: 'IN',
    id: 'silverthorne-homes',
  },
  {
    builderName: 'Arbor Homes',
    stateCd: 'KY',
    id: 'arbor-homes®',
  },
  {
    builderName: 'Elite Homes',
    stateCd: 'KY',
    id: 'elite-homes',
  },
  {
    builderName: 'Goodall Homes',
    stateCd: 'KY',
    id: 'goodall-homes',
  },
  {
    builderName: 'Summit Homes',
    stateCd: 'MO',
    id: 'summit-homes',
  },
  {
    builderName: 'Mungo Homes',
    stateCd: 'NC',
    id: 'mungo-homes',
  },
  {
    builderName: 'Arbor Homes',
    stateCd: 'OH',
    id: 'arbor-homes®',
  },
  {
    builderName: 'Mungo Homes',
    stateCd: 'SC',
    id: 'mungo-homes',
  },
  {
    builderName: 'Goodall Homes',
    stateCd: 'TN',
    id: 'goodall-homes',
  },
  {
    builderName: 'Brohn Homes',
    stateCd: 'TX',
    id: 'brohn-homes',
  },
  {
    builderName: 'Oakwood Homes',
    stateCd: 'UT',
    id: 'oakwood-homes',
  },
  {
    builderName: 'Mungo Homes',
    stateCd: 'VA',
    id: 'mungo-homes',
  },
];
const BuilderLinksByState = ({ section }) => {
  const isMobile =
    typeof window !== 'undefined' &&
    window.innerWidth <= lg_mobile_breakpoint + 103;
  const [isExpanded, setIsExpanded] = useState(!isMobile);

  var groupedBuildersByState = BuildersByState.reduce(
    (buildersObject, builder) => {
      const key = builder.stateCd;
      if (!buildersObject[key]) {
        buildersObject[key] = [];
      }
      buildersObject[key].push(builder);
      return buildersObject;
    },
    {}
  );
  return (
    <BuilderLinksByStateStyles>
      <div className="builders-state-container">
        <h2 style={{ color: extractColors(section.headerTextColor)?.[0] }}>
          <Markdown markdown={section?.sectionHeader} />
        </h2>
        <ul>
          <div className="builders-list-left">
            {Object.entries(groupedBuildersByState).map(
              ([key, builders], index) => {
                return (
                  index < (isMobile && !isExpanded ? 4 : 9) && (
                    <li key={key} style={{ marginTop: '24px' }}>
                      <b>{key}</b> -{' '}
                      {builders.map((builder, i) => (
                        <>
                          <a href={'#' + builder.id}>{builder.builderName}</a>{' '}
                          {builders.length == i + 1 ? '' : ', '}
                        </>
                      ))}
                    </li>
                  )
                );
              }
            )}
          </div>
          {(!isMobile || isExpanded) && (
            <div className="builders-list-right">
              {Object.entries(groupedBuildersByState).map(
                ([key, builders], index) => {
                  return (
                    index >= 9 && (
                      <li key={key} style={{ marginTop: '24px' }}>
                        <b>{key}</b> -{' '}
                        {builders.map((builder, i) => (
                          <>
                            <a href={'#' + builder.id}>{builder.builderName}</a>{' '}
                            {builders.length == i + 1 ? '' : ', '}
                          </>
                        ))}
                      </li>
                    )
                  );
                }
              )}
              <li key={'clayton'} style={{ marginTop: '24px' }}>
                <a href="#clayton">Clayton</a> - Available in 46 states
              </li>
            </div>
          )}
        </ul>
        <div className="view-all" style={{ 'margin-top': '24px' }}>
          {isMobile && !isExpanded && (
            <a onClick={() => setIsExpanded(!isExpanded)}>
              View All
              {!isExpanded ? (
                <ChevronDown viewBox="0 0 16 16"></ChevronDown>
              ) : (
                <ChevronUp viewBox="0 0 16 16"></ChevronUp>
              )}{' '}
            </a>
          )}
        </div>
      </div>
    </BuilderLinksByStateStyles>
  );
};

BuilderLinksByState.propTypes = {
  section: PropTypes.shape({
    sectionHeader: PropTypes.string,
    backgroundColor: PropTypes.string,
    component: PropTypes.string,
    headerTextColor: PropTypes.string,
  }),
};

export default BuilderLinksByState;
